import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-price-input',
  template: `
    <div>
      <input
        type="text"
        name="price"
        [ngClass]="{ 'input-error': isRequire }"
        (input)="transformPrice($event)"
        [value]="price_value"
        [readonly]="isReadOnly" />
    </div>
  `,
})
export class PriceInputComponent {
  @Output() onUpdate = new EventEmitter<any>();

  @Input() isRequire: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() field_value: any;
  @Input() isIconVisible: boolean = true;
  price_value: string = '';

  ngOnChanges(changes: SimpleChanges) {
    let change_value = changes['field_value'].currentValue;
    console.log('change_value >>:', change_value);
    if (changes['field_value'] && changes['field_value'].currentValue != null) {
      this.transformPrice(changes['field_value'].currentValue, false); // false => it's not from event
    }

    change_value == null && (this.price_value = '');
  }

  transformPrice(valueOrEvent: any, isEvent = true) {
    let rawValue: string;
    let inputEl: HTMLInputElement | null = null;

    if (isEvent) {
      inputEl = valueOrEvent.target as HTMLInputElement;
      rawValue = inputEl.value;
    } else {
      rawValue = String(valueOrEvent);
    }

    // Remember where the cursor was
    const oldCursor = isEvent && inputEl ? inputEl.selectionStart || 0 : 0;
    const charsBeforeCursor = rawValue.slice(0, oldCursor).replace(/[^0-9.]/g, '');

    // Split into integer & decimal parts
    let [integerPart = '', decimalPart = ''] = rawValue.split('.');

    // Format integer part with commas
    const formattedInteger = integerPart.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // ✅ keep only digits in decimal, then **pad to 2 digits if present**
    let formattedDecimal = '';
    if (rawValue.includes('.')) {
      decimalPart = decimalPart.replace(/\D/g, '');
      // keep exactly 2 decimal places (pad with zeros if needed)
      if (decimalPart.length > 2) decimalPart = decimalPart.slice(0, 2);
      formattedDecimal = '.' + decimalPart.padEnd(2, '0');
    }
    if (this.isIconVisible) {
      this.price_value = '$' + formattedInteger + formattedDecimal;
    } else {
      let plainValue = formattedInteger + formattedDecimal;
      this.price_value = plainValue.replace(/[^0-9.]/g, '');
    }

    // Emit numeric value as float
    const numericValue = parseFloat(this.price_value.replace(/[$,]/g, ''));
    this.onUpdate.emit(numericValue);

    // Restore cursor position
    if (isEvent && inputEl) {
      let matchCount = charsBeforeCursor.length;
      let newCursor = 0;
      for (let i = 0; i < this.price_value.length; i++) {
        if (/[0-9.]/.test(this.price_value[i])) {
          matchCount--;
          if (matchCount === 0) {
            newCursor = i + 1;
            break;
          }
        }
      }
      setTimeout(() => inputEl!.setSelectionRange(newCursor, newCursor));
    }
  }
}
